export enum RegelingOptions {
  BeschermdWonen = "BeschermdWonen",
  Buitenland = "ZorgverzekeringEnBuitenland",
  CBHC = "CBHC",
  Gemoedsbezwaarden = "Gemoedsbezwaarden",
  MedicijnenMeeOpReis = "MedicijnenMeeOpReis",
  OnverzekerbareVreemdelingen = "OnverzekerbareVreemdelingen",
  Onverzekerden = "Onverzekerden",
  SOV = "SOV",
  BetalingsachterstandZorgpremie = "BetalingsachterstandZorgpremie",
  Wlz = "ZorgVanuitDeWlz",
  WmoAT = "OndersteuningVanuitWmo",
  Onbekend = "Onbekend"
};